import React from 'react';
import Tooltip from './Tooltip';

const RecipeTooltip = ({ recipe, target, cookbooks, mobileMode, onClose }) => {
  if (!recipe) return null;

  const getCookbookTitle = (cookbookId) => {
    const cookbook = cookbooks.find(c => c.id === cookbookId);
    return cookbook ? cookbook.title : '';
  };

  return (
    <Tooltip target={target} mobileMode={mobileMode} onClose={onClose}>
      {mobileMode && (
        <div className="tooltip-header">
          <button className="icon-button close-tooltip-button" onClick={onClose}>
            <i className="material-icons">close</i>
          </button>
        </div>
      )}
      <h4>{recipe.name}</h4>
      <p>{getCookbookTitle(recipe.cookbookId)}{recipe.pageNumber && ` p.${recipe.pageNumber}`}</p>
      <hr />
      <ul style={
        (recipe.ingredients && recipe.ingredients.length > 0)
          ? {
            columnCount: Math.max(1, Math.ceil(recipe.ingredients.length / 10)),
            columnGap: '2rem',
            width: `${Math.max(1, Math.ceil(recipe.ingredients.length / 10)) * 250}px`
          }
          : {}
      }>
        {(recipe.ingredients || []).map((ingredient, index) => (
          <li key={index}>
            {ingredient.name} {ingredient.amount} {ingredient.unit}
          </li>
        ))}
      </ul>
      <hr />
      <p>Serves {recipe.servingSize || 4}</p>
    </Tooltip>
  );
};

export default RecipeTooltip;
